"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isQuoteByTickIndex = exports.isQuoteByPrice = void 0;
/*** Type Guards ***/
function isQuoteByPrice(param) {
    return (param.priceLower != null &&
        param.priceUpper != null);
}
exports.isQuoteByPrice = isQuoteByPrice;
function isQuoteByTickIndex(param) {
    return (param.tickLowerIndex != null &&
        param.tickUpperIndex != null);
}
exports.isQuoteByTickIndex = isQuoteByTickIndex;
